<template>
  <div class="modal" :class="show && 'is-active'">
    <div @click="close()" class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <h1 class="title is-1 text-center">{{ title }}</h1>

        <p class="content text-center">
          {{ message }}
        </p>

        <input
            class="title is-2 input"
            v-model="userInput"
            placeholder="team name"
            />
        <section class="button-container text-center">
          <button
            @click="confirm()"
            type='button'
            class='button is-primary'
            :class="loading && 'is-loading'">
            Confirm
          </button>
          <input
            @click="close()"
            type='button'
            class='button'
            value='Cancel' />
        </section>

      </div>
    </div>
    <button @click="close()" class="modal-close is-large"></button>
  </div>
</template>

<script>
import store from '../store.js'

export default {
  name: 'GetUserInput',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: 'Are you sure?',
    },
    title: {
      type: String,
      default: 'Confirm',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {
      userInput: '',
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    confirm () {
      store.state.userInput = this.userInput
      this.$emit('confirm')
    },
    handleESC (e) {
      const ESC = 27
      if (e.keyCode === ESC) {
        this.$emit('cancel')
      }
    },
  },
  created () {
    document.addEventListener('keydown', this.handleESC)
  },
  beforeDestory () {
    document.removeEventListener('keydown', this.handleESC)
  },
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.error-container {
  border-radius: 5px;
  padding: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>



// WEBPACK FOOTER //
// GetUserInput.vue?cf18bddc